import React, {createRef, useState, useRef} from 'react';
import moment from "moment";
import axios from "axios";
import { Grid } from "@material-ui/core";

import DateSelector from "../../../controls/DatePicker";
import AdhocFormDialog from "../../../controls/FormDialog";
//import AdhocTripValidator from "../../validators/AdhocAnnexValidator";
import ClientCompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import FuelAnnexUuidLookup from "./FuelAnnexUuidLookup";


export default (SystemData, apiSitePrefix, queryClient) => {

  const requestRef = createRef(0);
  const record = useRef({companyUuid: "null"});

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
  });

  const minDate = moment.utc().startOf('month').subtract(1, 'month');
  const initialDate = minDate.toISOString();
  const dateFormat = "DD/MM/YYYY";

  const show = () => {
    setDialogStates({...dialogStates, showDialog:true});
  }



  const generateAnnex = async (rowData) => {
    SystemData.toggleLoadingProgress(true);
    let response = null;
    try {
      response = await axios.post(`${apiSitePrefix}/fuelannexes/build/${rowData.fuelAnnexUuid}/${rowData.effectiveDate}`);
    } catch (err) {
      SystemData.openAlert(
        "Error",
        `An unexpected error has occurred generating the fuel annex.`
      ); 
      console.debug(err);
    }
    if (!response) {
      SystemData.openAlert(
        "Error",
        `An unexpected error has occurred generating the fuel annex.`
      ); 
    } else if (response.error) {
      SystemData.openAlert(
        "Error",
        `Error: ${response.error.errorMessage}`
      ); 
    } else {
      queryClient.invalidateQueries(["FuelAnnexesOutstanding"]);
      setDialogStates({...dialogStates, showDialog: false})
    }
    SystemData.toggleLoadingProgress(false);
  }

  const dialogBox = (
    <>
    {dialogStates.showDialog?
      <AdhocFormDialog
        title="Generate Adhoc Annex"
        message=""
        open={dialogStates.showDialog}
        record={{}}        
        dialogOptions={{maxWidth: "sm", fullWidth: true}}
        // validator={AdhocTripValidator}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            generateAnnex(record);
          } else {
            setDialogStates({...dialogStates, showDialog: false});
          }
        }}

      >
        <Grid container checkchildren="true" spacing={3}>
        <Grid item xs={6} checkchildren="true">
            <ClientCompanyUuidLookup
              id="companyName"
              label="Company"
              style={{width: "100%"}}
              returnType="object"
              onChange={(object, {recordChange})=>{
                if (object.found){
                  recordChange({companyName: object.data.companyName, companyUuid: object.data.companyUuid, fuelAnnexUuid: null, contractNo: null});
                } else {
                  recordChange({companyName: object.value, companyUuid: null, fuelAnnexUuid: null, contractNo: null});
                }
              }}            
            />
          </Grid>
          {(record) => (
            <Grid item xs={6} checkchildren="true">
              <FuelAnnexUuidLookup
                id="contractNo"
                label="Annex Contract"
                style={{width: "100%"}}
                returnType="object"
                companyUuid={record.companyUuid}
                onChange={(object, {recordChange})=>{
                  if (object.found){
                    recordChange({contractNo: object.data.contractNo, fuelAnnexUuid: object.data.fuelAnnexUuid});
                  } else {
                    recordChange({contractNo: object.value, fuelAnnexUuid: null});
                  }
                }}            
              />
            </Grid>
          )}
          <Grid item xs={6} checkchildren="true">
            <DateSelector
              id="effectiveDate"
              label="Effective Date"
              style={{width: "100%"}}
              minDate={initialDate}
              defaultValue={initialDate}
              disableToolbar={true}
              autoOk={true}
              format={dateFormat}
            />
          </Grid>
        </Grid>
      </AdhocFormDialog>
      :<></>
    }  
  </>
  )

  return {
    show,
    dialogBox
  }
}